var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{ mobile: _vm.isMobile, 'active-section': _vm.isActive },on:{"click":_vm.emitRedirected}},[_vm._v(" "+_vm._s(_vm.$t(`navigation.${_vm.name}`))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }